import { motion, useMotionValue, useSpring } from "framer-motion";
import { BOOKS } from "@/data/temple";
import { Sigil } from "./Sigil";
import { Eyebrow, Reveal } from "./Reveal";
import { scrollToId } from "@/lib/scroll";

const Cover = ({ b, i }) => {
  const rx = useSpring(useMotionValue(0), { stiffness: 120, damping: 14 });
  const ry = useSpring(useMotionValue(-14), { stiffness: 120, damping: 14 });
  const move = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    ry.set(((e.clientX - r.left) / r.width - 0.5) * 30);
    rx.set(-((e.clientY - r.top) / r.height - 0.5) * 20);
  };
  const leave = () => {
    rx.set(0);
    ry.set(-14);
  };
  return (
    <Reveal delay={i * 0.1} className="[perspective:1100px]">
      <motion.div
        data-testid={`book-cover-${i + 1}`}
        onMouseMove={move}
        onMouseLeave={leave}
        style={{ rotateX: rx, rotateY: ry, backgroundColor: b.tone, transformStyle: "preserve-3d" }}
        className="relative aspect-[2/3] rounded-r-md shadow-[30px_40px_60px_-20px_rgba(0,0,0,0.9)] border border-[#D9B47A]/25 overflow-hidden"
      >
        <span className="absolute left-0 top-0 bottom-0 w-3 bg-gradient-to-r from-black/60 to-transparent" />
        <div className="absolute inset-4 border border-[#D9B47A]/40 flex flex-col items-center justify-between py-8 px-5 text-center">
          <span className="font-tt-mono text-[11px] uppercase tracking-[0.35em] text-[#D9B47A]">Book {b.n}</span>
          <Sigil className="w-14 h-14" width={2.5} />
          <div>
            <p className="font-display text-xl leading-tight text-[#F2E8DF]">{b.title}</p>
            <p className="font-display italic text-sm text-[#D9B47A] mt-3 leading-snug">{b.sub}</p>
          </div>
          <span className="font-tt-mono text-[10px] uppercase tracking-[0.3em] text-[#CFC2B6]">Goddess Ariel</span>
        </div>
        <span className="pointer-events-none absolute inset-0 bg-gradient-to-tr from-transparent via-white/[0.06] to-transparent" />
      </motion.div>
      <p className="mt-6 text-[15px] text-[#CFC2B6] leading-relaxed">{b.d}</p>
    </Reveal>
  );
};

export default function Books() {
  return (
    <section id="books" data-testid="books-section" className="relative max-w-[1440px] mx-auto px-5 sm:px-10 py-28 sm:py-40">
      <Reveal className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
        <div>
          <Eyebrow n="VII">The Sacred Series</Eyebrow>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-8 leading-[1.05]">
            Four volumes. <em className="text-[#D9B47A]">One</em> living temple.
          </h2>
        </div>
        <button
          data-testid="books-enquire-btn"
          onClick={() => scrollToId("enter")}
          className="self-start lg:self-auto rounded-full border border-[#D9B47A]/60 px-6 py-3 font-tt-mono text-[12px] uppercase tracking-[0.2em] hover:bg-[#D9B47A] hover:text-[#0A0706] transition-colors duration-300"
        >
          Enquire about the books
        </button>
      </Reveal>
      <div className="mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 sm:gap-10">
        {BOOKS.map((b, i) => <Cover key={b.n} b={b} i={i} />)}
      </div>
    </section>
  );
}
